<template>
  <div id="app-filter-openings">

    <!-- List of children -->
    <div v-for="(child,index) in children">
      <jackrabbit-child :ref="'child-' + (index+1)"
                        :jr_endpoint="jr_endpoint"
                        :child_index="index+1"
                        :child="child"
                        :category2="category2"
                        :color="colors[index+1]"
                        :color-for-category2="colorForCategory2"
                        :color-for-category3="colorForCategory3"
                        @remove="removeChild(index)"
      ></jackrabbit-child>
    </div>

    <div style="margin-top: 30px" v-if="children.length < 10">
      <button class="add-child-button" @click.prevent="addChild"
      >{{ str_add_child }}</button>
    </div>


    <div style="text-align: right; padding: 10px">
      <label style="font-weight: bold; cursor: pointer">
        <input type="checkbox" v-model="hideDisabled"> <span>{{ str_hide_disabled }}</span>
      </label>
    </div>

    <div class="calender-wrapper" style="min-height: 560px">
      <div class="calender-column" v-for="(item, index) in week">
        <div class="calender-header"><span>{{ item.label }}</span></div>
        <div class="calender-days-wrapper">
          <div class="accordian-wrapper">
            <accordian-item v-for="(opening ,index2) in openingsForWeekday(item.weekday)"
                            :key="index2" :opening="opening" :color="colorForOpening(opening)" _color="colors[opening.child_index]"
                            :hide-disabled="hideDisabled"
            ></accordian-item>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import JackrabbitChild from "./components/JackrabbitChild";
import AccordianItem from "./components/AccordianItem";
export default {
  components: {JackrabbitChild, AccordianItem},

  data() {
    return {
      jr_endpoint: window.JACKF.jackrabbit_url +  window.JACKF.ORGID,

      // Selectors to load the first child
      sel1: window.JACKF.SEL1,
      sel2: window.JACKF.SEL2,

      week: [
        {
          weekday: 7,
          label: 'Sunday',
          openings: []
        },
        {
          weekday: 1,
          label: 'Monday',
          openings: []
        },
        {   weekday: 2,
          label: 'Tuesday',
          openings: []
        },
        {
          weekday: 3,
          label: 'Wednesday',
          openings: []
        },
        {
          weekday: 4,
          label: 'Thursday',
          openings: []
        },
        {
          weekday: 5,
          label: 'Friday',
          openings: []
        },
        {
          weekday: 6,
          label: 'Saturday',
          openings: []
        }
      ],
      children: [],
      colors: [
        '#82d1ec',
        '#82a4ec',
        '#b582ec',
        '#ec82c7',
        '#ec8286',
        '#ecab82',
        '#ead64e',
        '#56e396',
        '#1ec25f',
        '#4f9aef',
      ],
      str_add_child: "Add Child",
      str_hide_disabled: "Available",
      rows: [],
      category1: [], //window.JACKE.category1.sort(),
      category2: [], //window.JACKE.category2.sort(),
      category3: [], //window.JACKE.category3.sort(),
      hideDisabled: false,


    }
  },

  created(){
    this.captureUrlParams()
    this.loadOpenings()
  },

  methods: {

    __(label) {
      return label
    },

    // PARAMS FROM THE URL
    // ?orgid=505941&sel1=3%20to%205%20yrs&sel2=Skill%20Development
    captureUrlParams() {
      const queryString = window.location.search;
      //console.log(queryString);

      const urlParams = new URLSearchParams(queryString);
      const orgid = urlParams.get('orgid')
      //console.log('orgid = ' + orgid)

      const sel1 = urlParams.get('sel1')
      //console.log('sel1 = ' + sel1)

      const sel2 = urlParams.get('sel2')
      //console.log('sel2 = ' + sel2)

      if (orgid) {
        this.jr_endpoint = window.JACKF.jackrabbit_url + orgid
      }

      if (sel1) {
        this.sel1 = sel1
      }

      if (sel2) {
        this.sel2 = sel2
      }

    },

    loadOpenings(){
      //console.log('Load openings ' + this.jr_endpoint)
      jQuery.getJSON(this.jr_endpoint, (response) => {
        //console.log(response)
        if (response.success) {
          this.rows = response.rows
          this.extractCategories()
          this.prepareFirstChild()
        }
      })
    },

    extractCategories() {
      for (let i = 0; i < this.rows.length; i++)
      {
        let cat1 = this.rows[i].category1
        if (cat1.length > 2 && !this.category1.includes(cat1)) {
          this.category1.push(cat1)
        }

        let cat2 = this.rows[i].category2
        if (cat2.length > 2 && !this.category2.includes(cat2)) {
          this.category2.push(cat2)
        }

        let cat3 = this.rows[i].category3
        if (cat3.length > 2 && !this.category3.includes(cat3)) {
          this.category3.push(cat3)
        }
      }
    },

    prepareFirstChild() {
        if (this.sel1) {
          this.addChild()
          this.$nextTick(() => {
            console.log(this.$refs)
            this.$refs['child-1'][0].loadSelectors(this.sel1, this.sel2)
          })
        }
    },

    addChild() {
      if (this.children.length >= 10) return
      this.children.push(
          {
            added: false,
            category2: '',
            category3: '',
            openings: []
          }
      )
    },

    removeChild(index) {
      let children = []
      for (let i = 0; i < this.children.length; i++){
        if (index != i){
          children.push(this.children[i])
        }
      }
      this.children = children
    },

    openingsForWeekday(weekday) {
      let openings = []
      for (let i = 0; i < this.children.length; i++){
        if (this.children[i].added){
          for (let j = 0; j < this.children[i].openings.length; j++) {
            if (this.children[i].openings[j].week_day_index == weekday){
              openings.push(this.children[i].openings[j])
            }
          }
        }
      }

      if (typeof openings == undefined || openings.length == 0) return []
      //console.log(openings)

      // @todo Sort by start_time
      //return openings
      return _.sortBy(openings, 'start_time')
    },

    colorForCategory2(cat) {
      //console.log('Category2 for ' + cat)
      let index = 0
      for (let i = 0; i < this.category2.length; i++){
        if (this.category2[i] == cat) {
          index = i
        }
      }
      return this.colors[index % this.colors.length]
    },

    colorForCategory3(cat) {
      //console.log('Category3 for ' + cat)
      let index = 0
      for (let i = 0; i < this.category3.length; i++){
        if (this.category3[i] == cat) {
          index = i
        }
      }
      return this.colors[index % this.colors.length]
    },

    colorForOpening(opening) {
      //console.log(opening)
      //return this.colors[3]

      let child = this.children[opening.child_index-1]

      if (child.category2){
        return this.colorForCategory2(child.category2)
      }
      return this.colors[0]

    }

  }, // :methods
}
</script>
